import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';

import {NotificationContainer} from 'react-notifications';

import AccountMenu from './AccountMenu';
import Loader from '../utils/Loadersmall';

class Orders extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orderlist:[],
            serviceCheck:false,
        }   
    }

    async componentDidMount() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
          const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/orderList', params);
           let resVal=response.data;
            if(resVal.status==='success'){
                this.setState({orderlist:resVal.data});
                this.setState({serviceCheck:true});
            }
        } catch (error) {
            this.setState({serviceCheck:true});
          console.error(error);
        }

    }


    render() {
        if(this.state.serviceCheck===false)
        return (<Loader/>);

        const orderCount = this.state.orderlist.length;
        const totalSpent = this.state.orderlist.reduce((sum, order) => {
            const orderTotal = Number(order.total_amount || 0);
            return sum + (Number.isFinite(orderTotal) ? orderTotal : 0);
        }, 0);
        const latestOrder = orderCount > 0 ? this.state.orderlist[0] : null;
        const latestOrderLabel = latestOrder && latestOrder.order_date ? latestOrder.order_date : 'No recent orders';

        return (
            <div className="ps-account-page ps-account-page--profile">
                <div className="ps-categogy ps-categogy--separate ps-account-shell">
                    <div className="container whiteContainer ps-account-shell__container">
                        <div className="ps-account-shell__layout">
                            <AccountMenu {...this.props}/>

                            <main className="ps-account-shell__content">
                                <div className="ps-account-shell__topbar">
                                    <ul className="ps-breadcrumb ps-account-shell__breadcrumb">
                                        <li className="ps-breadcrumb__item"><Link to="/">Account settings</Link></li>
                                        <li className="ps-breadcrumb__item active" aria-current="page">Orders</li>
                                    </ul>
                                    <div className="ps-account-shell__eyebrow">Order history</div>
                                </div>

                                <section className="ps-account-shell__hero ps-orders__hero">
                                    <div className="ps-account-shell__heroCopy">
                                        <span className="ps-account-shell__label">Your purchases</span>
                                        <h1>Track every order with clarity</h1>
                                        <p>Review purchases, check delivery status, and keep your order history organized in one clean dashboard.</p>
                                    </div>
                                    <div className="ps-orders__heroStats">
                                        <div className="ps-orders__heroStat">
                                            <span>Orders</span>
                                            <strong>{orderCount}</strong>
                                        </div>
                                        <div className="ps-orders__heroStat">
                                            <span>Total spent</span>
                                            <strong>&#8377; {totalSpent.toFixed(0)}</strong>
                                        </div>
                                        <div className="ps-orders__heroStat">
                                            <span>Latest</span>
                                            <strong>{latestOrderLabel}</strong>
                                        </div>
                                    </div>
                                </section>

                                <section className="ps-account-shell__panel">
                                    {(this.state.orderlist.length>0)?
                                        <div className="ps-orders__body">
                                            {this.state.orderlist.map((data, orderIndex)=>{
                                                const orderItems = Array.isArray(data.order_items) ? data.order_items : [];
                                                const statusName = (data.order_status || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, '-');
                                                return(
                                                    <article className="ps-order-card" key={`${data.order_code || 'order'}-${orderIndex}`}>
                                                        <div className="ps-order-card__header">
                                                            <div className="ps-order-card__titleWrap">
                                                                <div className="ps-order-card__title">Order #{data.order_code}</div>
                                                                <div className="ps-order-card__meta">
                                                                    <span className="ps-order-card__date">Placed on {data.order_date}</span>
                                                                    <span className={`ps-order-card__status ${statusName ? `ps-order-card__status--${statusName}` : ''}`}>{data.order_status}</span>
                                                                </div>
                                                            </div>
                                                            <div className="ps-order-card__actions">
                                                                {data.tracking_number ? <span className="ps-order-card__chip">Tracking No.: {data.tracking_number}</span> : null}
                                                                {data.tracking_partner ? <span className="ps-order-card__chip">Partner: {data.tracking_partner}</span> : null}
                                                                {data.tracking_url ? <a target="_blank" rel="noreferrer" href={data.tracking_url} className="ps-order-card__track">Track order</a> : null}
                                                            </div>
                                                        </div>

                                                        <div className="ps-order-card__grid">
                                                            <div className="ps-order-card__info">
                                                                <p className="ps-order-card__label">Contact</p>
                                                                <p className="ps-order-card__text">Name: {data.contact_person_name}<br/>Phone: {data.contact_number}</p>
                                                            </div>
                                                            <div className="ps-order-card__info">
                                                                <p className="ps-order-card__label">Shipping address</p>
                                                                <p className="ps-order-card__text">{data.shipping_address}</p>
                                                            </div>
                                                            <div className="ps-order-card__info">
                                                                <p className="ps-order-card__label">Payment</p>
                                                                <p className="ps-order-card__text"><span className="ps-order-card__payment">{data.payment_mode}</span><br/>Shipping fee: &#8377; {data.shipping_amount}<br/>Total paid: &#8377; {data.total_amount}</p>
                                                            </div>
                                                        </div>

                                                        <div className="ps-order-card__sectionTitleRow">
                                                            <div className="ps-order-card__sectionTitle">Ordered items</div>
                                                            <div className="ps-order-card__sectionHint">{orderItems.length} item{orderItems.length === 1 ? '' : 's'}</div>
                                                        </div>
                                                        <ul className="row orderProductList ps-order-card__items">
                                                            {orderItems.length>0 ?
                                                                orderItems.map((dataItems, itemIndex)=>{
                                                                    return(
                                                                        <li className="col-lg-6 col-md-6 col-sm-12" key={`${data.order_code || 'order'}-${itemIndex}`}>
                                                                            <div className="ps-order-item">
                                                                                <div className="ps-order-item__image">
                                                                                    <img src={dataItems.product_image} alt={dataItems.product_name} />
                                                                                </div>
                                                                                <div className="ps-order-item__info">
                                                                                    <p className="ps-order-item__title">{dataItems.product_name}</p>
                                                                                    <div className="ps-order-item__meta">
                                                                                        <span className="ps-order-item__pill">Qty {dataItems.product_quantity}</span>
                                                                                        <span className="ps-order-item__pill ps-order-item__pill--muted">&#8377; {dataItems.product_price} each</span>
                                                                                    </div>
                                                                                    <div className="ps-order-item__footer">
                                                                                        <span className="ps-order-item__footerLabel">Total</span>
                                                                                        <span className="ps-order-item__total">&#8377; {dataItems.product_total}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    )
                                                                })
                                                            : null}
                                                        </ul>
                                                    </article>
                                                )
                                            })}
                                        </div>
                                    :
                                        <div className="ps-orders__empty">
                                            <img src="/assets/img/orders-empty.svg" className="ps-orders__emptyImage" alt="No orders found" />
                                            <span className="ps-orders__emptyLabel">Order history</span>
                                            <h4>No orders yet</h4>
                                            <p>There are no orders in your account yet. Browse Natureway products and place your first order to see it here.</p>
                                            <div>
                                                <Link to="/" className="ps-orders__ctaButton">Continue Shopping</Link>
                                            </div>
                                        </div>
                                    }
                                </section>
                            </main>
                        </div>
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        );
    }
}

export default Orders;
